export const HOME = { emergentLink: "emergent-link" };

export const AUTH = {
  emailInput: "login-email-input",
  passwordInput: "login-password-input",
  submitBtn: "login-submit-btn",
  logoutBtn: "logout-btn",
};

export const NAV = {
  dashboard: "nav-dashboard",
  orders: "nav-orders",
  board: "nav-board",
  matching: "nav-matching",
  customers: "nav-customers",
  products: "nav-products",
  inventory: "nav-inventory",
  reports: "nav-reports",
  users: "nav-users",
  settings: "nav-settings",
};
